import creator from '../helpers/creator'
import Animate from './Animate'
import Tabs from './Tabs'
import Search from './Search'
import Token from './Token'
import OverlayLayer from "./OverlayLayer"
import Parallax from './Parallax'
import Swiper, { Pagination } from 'swiper'
Swiper.use([Pagination])

class FetchWithParam {
  constructor() {
    this.windowRef = window.location.href
    this.overlay = null
    this.id = 0
    this.hash = 0
    this.events = []
    this.url = null
    this.cookie = window.token.getCookie('DIOR_GM_30')
    this.initialize()

  }

  initialize() {
    if(this.windowRef.includes('?url') && this.cookie != '') {
      this.getData()
      this.bindEvents()
    } else {
      window.token = new Token()
    }
  }

  bindEvents() {
    window.addEventListener('fetch:done', () => {
      window.overlaylayer = new OverlayLayer(this.id, this.hash)
      this.createSlider(window.overlaylayer)
    })
  }

  getData() {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const page_slug = urlParams.get('url')
    const page_id = urlParams.get('id')
    this.hash = window.location.hash
    this.id = `parent-${page_id}`

    const subpageId = this.hash.replace('#page-', '')

    this.fetchData(page_slug, subpageId)
  }

  async fetchData(url, subid) {
    let myHeaders = new Headers()
    myHeaders.append("x-custom-provider", "dior-montaigne")
    let lang = window.location.pathname.split('/')[1]
    if (lang) {
      this.url = `${window.location.origin}/${lang}/${url}`
    } else {
      this.url = `${window.location.origin}/${url}`
    }

    await fetch(this.url, {headers: myHeaders})
    .then(response => response.text())
    .then(html => {
      // Convert the HTML string into a document object
      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      let content = doc.querySelector('body').innerHTML
      let overlay = document.querySelector(`.js-overlay-child[data-id="${subid}"]`)
      overlay.innerHTML = content

      window.tabs = creator('.js-tabs', Tabs)
      window.search = new Search()
    })
    .then(() => {
      if (window.tabs.length > 4) {
        const event = new CustomEvent("fetch:done")

        setTimeout(() => {
          window.dispatchEvent(event)
        }, 300)
      }
    })
    .catch(err => {
      console.error('Failed to fetch one or more of these URLs:');
      console.error(err);
    })
  }

  createSlider(overlay) {
    let stickyHeader = document.querySelector('.js-overlay-header-mini')
    let slider = overlay.ui.$overlay.querySelector('.js-slider') 
    if (window.sliderdefault) {
      window.sliderdefault.destroy()
      window.sliderdefault = undefined
    }

    window.sliderdefault = new Swiper(slider, {
      spaceBetween: 16,
      autoHeight: true,
      observer: true,
      threshold: 20,
      pagination: {
        el: ".js-pagination",
      }
    })
    let hash = window.location.hash.substring(1)
    let slide = slider.querySelector('[data-hash="'+hash+'"]')
    let index = slide.getAttribute('data-index')
    window.sliderdefault.activeIndex = parseInt(index)
    window.sliderdefault.realIndex = parseInt(index)
    window.sliderdefault.updateAutoHeight(300)
    let activeSlide = window.sliderdefault.slides[window.sliderdefault.activeIndex]

    let overlayClose = activeSlide.querySelector('.js-overlay-close')
    let overlayTitle = activeSlide.querySelector('.js-overlay-title')
    let overlayPagination = activeSlide.querySelector('.js-pagination')

    if(!stickyHeader.hasChildNodes()) {
      let close = overlayClose.cloneNode(true)
      let title = overlayTitle.cloneNode(true)
      let pagination = overlayPagination.cloneNode(true)
      let bullets = pagination.querySelectorAll('.swiper-pagination-bullet')

      stickyHeader.append(close)
      stickyHeader.append(title)
      stickyHeader.append(pagination)

      for (let i = 0; i < bullets.length; i++) {
        bullets[i].classList.remove('swiper-pagination-bullet-active')
      }

      bullets[window.sliderdefault.activeIndex].classList.add('swiper-pagination-bullet-active')
    }

    let images = activeSlide.querySelectorAll('.js-parallax')
    if (images.length > 0) {
      window.parallax = new Parallax(images)
    }

    if(
      activeSlide.classList.contains('template-history') || 
      activeSlide.classList.contains('archive-artist') ||
      activeSlide.classList.contains('template-map-dark')
    ) {
      stickyHeader.classList.add('overlay-header-mini--dark')
    }

    window.animate = new Animate()

    let id = activeSlide.querySelector('.js-overlay-child').getAttribute('data-id')
    let pathUrl

    window.fetchdata.items.forEach(item => {
      if (item.id == id) {
        pathUrl = new URL(item.url)
      }
    });
  }
}

export default FetchWithParam
